import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from 'src/app/core/base/base.component';
import { SecurityOptionProfileView } from 'src/app/model/security/option-profile';

@Component({
  selector: 'ms-khuyana-header-menu',
  templateUrl: './khuyana-header-menu.component.html',
})
export class KhuyanaHeaderMenuComponent extends BaseComponent {
  @Input() options: SecurityOptionProfileView[] = [];
  @Input() isDoctor?: boolean;
  @Output() leave = new EventEmitter<boolean>();

  constructor() {
    super();
  }

  onLinkClick = () => {
    this.options.forEach(this.collapseMenu);
    this.leave.emit(true);
  };

  private collapseMenu = (option: SecurityOptionProfileView) => {
    option.isSelected = false;
    option.children?.forEach(this.collapseMenu);
  };
}
